import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-16c04040"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "usi" }
const _hoisted_2 = { class: "usi__elm-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "usi__elm",
      style: _normalizeStyle({ background: _ctx.status(_ctx.value).color })
    }, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.status(_ctx.value).label), 1)
    ], 4)
  ]))
}